'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationEmailFailedAsync = exports.VerificationEmailSentAsync = exports.GdprMessageAsync = exports.NotificationListAsync = exports.StepHeaderAsync = undefined;

var _MakeLoadable = require('./MakeLoadable');

var _MakeLoadable2 = _interopRequireDefault(_MakeLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepHeaderAsync = exports.StepHeaderAsync = (0, _MakeLoadable2.default)(function () {
  return import( /* webpackChunkName: "bundles/header" */'../StepHeader');
});

var NotificationListAsync = exports.NotificationListAsync = (0, _MakeLoadable2.default)(function () {
  return import( /* webpackChunkName: "bundles/notifications" */'ReduxMessenger/components/NotificationList');
});

var GdprMessageAsync = exports.GdprMessageAsync = (0, _MakeLoadable2.default)(function () {
  return import( /* webpackChunkName: "bundles/terms" */'../survey/gdpr/GdprMessage');
});

var VerificationEmailSentAsync = exports.VerificationEmailSentAsync = (0, _MakeLoadable2.default)(function () {
  return import( /* webpackChunkName: "bundles/verification-email" */'../verified/VerificationEmailSent');
});

var VerificationEmailFailedAsync = exports.VerificationEmailFailedAsync = (0, _MakeLoadable2.default)(function () {
  return import( /* webpackChunkName: "bundles/verification-email" */'../verified/VerificationEmailFailed');
});